var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-avatar',[(!_vm.image)?_c('v-progress-circular',{key:"loading-image",attrs:{"indeterminate":"","color":"primary"}}):_c('img',{key:"image-loaded",attrs:{"height":"64","src":_vm.image,"aspect-ratio":"0.5"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }